<template>
  <div>
    <Breadcrumbs main="Settings" title="Settings" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h5 class="mb-0">Firm Settings</h5>
              <span class="text-muted">Manage case classes, case types, and event types for your firm</span>
            </div>
            <div class="card-body">
              <ul class="nav nav-tabs border-tab mb-3" role="tablist">
                <li v-for="tab in tabs" :key="tab.id" class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    :class="{ active: activeTab === tab.id }"
                    type="button"
                    role="tab"
                    :aria-selected="activeTab === tab.id"
                    @click="activeTab = tab.id"
                  >
                    {{ tab.label }}
                  </button>
                </li>
              </ul>

              <div class="tab-content">
                <SettingsLookupPanel
                  v-show="activeTab === 'caseclass'"
                  :active="activeTab === 'caseclass'"
                  title="Case Class"
                  list-title="Case Classes"
                  subtitle="Categorize matters (e.g. Civil, Criminal)"
                  field-label="Class name"
                  field-placeholder="e.g. Civil"
                  field-name="className"
                  id-field="caseClassId"
                  label-field="className"
                  add-button-label="Add Case Class"
                  delete-message="The case class will be soft-deleted and hidden from the list. The record is retained for audit."
                  :show-deleted-column="false"
                  :can-add="canAdd"
                  :can-delete="canDelete"
                  :list-fn="listCaseClasses"
                  :add-fn="addCaseClass"
                  :remove-fn="removeCaseClass"
                />

                <SettingsLookupPanel
                  v-show="activeTab === 'casetype'"
                  :active="activeTab === 'casetype'"
                  title="Case Type"
                  list-title="Case Types"
                  subtitle="Describe the kind of legal proceeding (e.g. Appeal, Trial)"
                  field-label="Case type"
                  field-placeholder="e.g. Appeal"
                  field-name="caseType"
                  id-field="caseTypeId"
                  label-field="caseType"
                  add-button-label="Add Case Type"
                  delete-message="This case type will be permanently deleted from the database."
                  :can-add="canAdd"
                  :can-delete="canDelete"
                  :list-fn="listCaseTypes"
                  :add-fn="addCaseType"
                  :remove-fn="removeCaseType"
                />

                <SettingsLookupPanel
                  v-show="activeTab === 'eventtype'"
                  :active="activeTab === 'eventtype'"
                  title="Event Type"
                  list-title="Event Types"
                  subtitle="Label calendar and diary entries (e.g. Hearing, Filing)"
                  field-label="Type name"
                  field-placeholder="e.g. Hearing"
                  field-name="typeName"
                  id-field="eventTypeId"
                  label-field="typeName"
                  add-button-label="Add Event Type"
                  delete-message="This event type will be permanently deleted from the database."
                  :can-add="canAdd"
                  :can-delete="canDelete"
                  :list-fn="listEventTypes"
                  :add-fn="addEventType"
                  :remove-fn="removeEventType"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SettingsLookupPanel from '@/components/settings/SettingsLookupPanel.vue'
import {
  listCaseClasses,
  addCaseClass,
  removeCaseClass,
  listCaseTypes,
  addCaseType,
  removeCaseType,
  listEventTypes,
  addEventType,
  removeEventType,
} from '@/services/settingsService'

function hasSettingsPrivilege(user, action) {
  if (!user?.privileges?.length) return true
  const settingsPriv = user.privileges.find((p) => p.entity === 'SETTINGS')
  if (!settingsPriv) return false
  const map = {
    view: 'canView',
    add: 'canAdd',
    delete: 'canDelete',
  }
  return settingsPriv[map[action]] === true
}

export default {
  name: 'TenantSettings',

  components: {
    SettingsLookupPanel,
  },

  computed: {
    ...mapGetters('auth', ['currentUser']),

    canAdd() {
      return hasSettingsPrivilege(this.currentUser, 'add')
    },

    canDelete() {
      return hasSettingsPrivilege(this.currentUser, 'delete')
    },
  },

  data() {
    return {
      activeTab: 'caseclass',
      tabs: [
        { id: 'caseclass', label: 'Case Classes' },
        { id: 'casetype', label: 'Case Types' },
        { id: 'eventtype', label: 'Event Types' },
      ],
      listCaseClasses,
      addCaseClass,
      removeCaseClass,
      listCaseTypes,
      addCaseType,
      removeCaseType,
      listEventTypes,
      addEventType,
      removeEventType,
    }
  },
}
</script>
